<app-static-pages-header [title]="'Datenschutzrichtlinien'"></app-static-pages-header>
<div class="container data-policy">
  <div class="row justify-content-md-center">
    <div class="col-md-8">
      <h2 class="main__title">DATENSCHUTZINFORMATION der SFA GmbH.</h2>
      <p>
        Diese Datenschutzerklärung gibt Ihnen einen Überblick über die Verarbeitung 
        Ihrer Daten bei der SFA Sport GmbH („SFA“). Sie gilt für alle Websites, Apps 
        und weiteren Dienste und Leistungen, die von SFA angeboten werden.
        Falls Sie eine Frage zu dieser Datenschutzerklärung oder zum Thema Datenschutz 
        bei SFA haben, können Sie sich an unser Team unter 
        <a href="mailto:info@fan.at">info@fan.at</a> wenden. 
        Bitte senden Sie auch eine E-Mail an unser Team, wenn Sie Ihr Recht 
        auf Auskunft oder Datenlöschung oder ein anderes Datenschutzrecht nach Art. 15-22 DSGVO 
        geltend machen wollen.
      </p>

      <div class="data-policy__item">
        <h4>1. Verarbeitungstätigkeit</h4>
        <ol class="list-alpha__low">
          <li>
            Betrieb einer Plattform samt Android und iOS-Apps zur medialen Darstellung
            von Sportvereinen und deren Mitgliedern in gemeinsam Verantwortung
          </li>
          <li>
            Betrieb eines Mediums zur Berichterstattung über Sportereignisse
          </li>
          <li>
            Online-Abrufbarhaltung von Informationen über das Unternehmen des Verantwortlichen und
            dessen Produkte für Interessenten und Kunden (derzeit abrufbar unter www.fan.at sowie
            den Social-Media-Channels des Verantwortlichen)
          </li>
        </ol>
      </div>
      <div class="data-policy__item">
        <h4>2. Verantwortlicher</h4>
        <p style="padding-left: 20px">SFA Sport GmbH („SFA“)<br/>
          Geidorfplatz 1/10<br/>
          A-8010 Graz<br/>
          E-Mail: <a href="mailto:info@fan.at">info@fan.at</a>
        </p>
      </div>
      <div class="data-policy__item">
        <h4>3. Kontaktdaten des Datenschutzverantwortlichen</h4>
        <p style="padding-left: 20px">SFA Sport GmbH („SFA“)<br/>
          Geidorfplatz 1/10<br/>
          A-8010 Graz<br/>
          c/o Datenschutzverantwortlicher<br/>
          E-Mail: <a href="mailto:info@fan.at">info@fan.at</a>
        </p>
      </div>
      <div class="data-policy__item">
        <h4>4. Zwecke der Datenverarbeitung</h4>
        <ul>
          <li>
            <h5>auf der Rechtsgrundlage der Kommunikationsfreiheit</h5>
            <p>
              Der Hauptzweck der Datenverarbeitung durch den Verantwortlichen ist der Betrieb eines
              Medienunternehmens und die Bereitstellung einer Plattform zur Präsentation von Sportvereinen
              <u>in gemeinsamer Verantwortung</u> mit dem jeweiligen Verein. Die Datenverarbeitung erfolgt daher
               auf der konventions- und verfassungsrechtlich (Art 13 StGG; Art 10 EMRK) geschützten
              Grundlage der Presse-, Meinungs- und Kommunikationsfreiheit.
            </p>
          </li>
          <li>
            <h5>auf der Rechtsgrundlage <u>der Vertragserfüllung oder -vorbereitung</u></h5>
            <ol class="list-alpha__low">
              <li>
                <p>
                  Vertrieb von Online-Medieninhalten an (registrierte) Kunden, auch in
                  personalisierter Form unter Berücksichtigung von Vorlieben
                </p>
              </li>
              <li>
                <p>
                  Verbreitung von eigener und fremder Werbung in Online-Medien zur Finanzierung
                  der Online-Medieninhalte
                </p>
              </li>
              <li>
                <p>
                  Erhaltung und Erhöhung der Kundenzufriedenheit und der Kundenbindung durch
                  Veranstaltung von Gewinnspielen, Events und Kundenbefragungen
                </p>
              </li>
              <li>
                <p>
                  Bereitstellung von Kommunikationskanälen zu SFA zur Servicierung des Vertragsverhältnisses
                </p>
              </li>
              <li>
                <p>
                  Auswertung des Nutzungs- und Leserverhaltens und der persönlichen Vorlieben der
                  Kunden zur zielgerichteten Verbreitung von Inhalten
                </p>
              </li>
            </ol>
          </li>
          <li>
            <h5>auf der Rechtsgrundlage der (jederzeit mit Wirkung für die Zukunft widerruflichen) Einwilligung</h5>
            <ol class="list-alpha__low">
              <li>
                <p>
                  Verbreitung von eigener und fremder Werbung in Online-Medien, auch in personalisierter
                  Form unter Berücksichtigung von Vorlieben und des Nutzungsverhaltens
                </p>
              </li>
              <li>
                <p>
                  Übermittlung von elektronischen Identifikationsdaten des Kunden an Werbepartner, um diesen
                  die gesteuerte Ausspielung und die Auswertung der Werbemittel zu ermöglichen, dies unter
                  Einsatz von Trackingmethoden und unter Setzung/Auslesung von Cookies und anderen
                  Identifizierungsmerkmalen
                </p>
              </li>
              <li>
                <p>
                  Einbettung von Inhalten Dritter in die Online-Medieninhalte zu Informationszwecken
                </p>
              </li>
            </ol>
          </li>
          <li>
            <h5>auf der Rechtsgrundlage der (überwiegenden) berechtigten Interessen von SFA</h5>
            <ol class="list-alpha__low">
              <li>
                <p>Rückgewinnung sowie Neugewinnung von Kunden zur Steigerung der Reichweite</p>
              </li>
              <li>
                <p>
                  Verbreitung/Ausspielung von Werbung für (weitere) Waren und Dienstleistungen von SFA
                  im Wege der Direktwerbung („Marketingzwecke“), soweit gesetzlich zulässig
                </p>
              </li>
              <li>
                <p>
                  Auswertung des Leserverhaltens und der persönlichen Vorlieben der Kunden zur
                  zielgerichteten Verbreitung von Werbung mit dem Ziel der Vermeidung von Streuverlusten
                </p>
              </li>
              <li>
                <p>
                  Erhebung der Nutzerzahlen zur Dokumentation der Reichweite, insbesondere auch
                  durch die Österreichische Webanalyse
                </p>
              </li>
              <li>
                <p>Erhebung des Nutzungsverhaltens zur Verbesserung der Services</p>
              </li>
            </ol>
          </li>
        </ul>
      </div>
      <div class="data-policy__item">
        <h4>5. Zweckänderung</h4>
        <p style="padding-left: 20px">
          <strong><u>Direktwerbung:</u></strong> SFA informiert, dass sie die personenbezogenen Daten des
          Kunden auch zu Zwecken der Direktwerbung verarbeitet. Mit der Direktwerbung will SFA
          den Vertrieb der beworbenen (eigenen oder fremden) Produkte fördern.
          <strong><u>Zu diesem Zweck werden diese Daten keinem (nicht konzernverbundenen)
            Dritten überlassen.</u></strong>
        </p>
      </div>
      <div class="data-policy__item">
        <h4>6. Widerspruch gegen die Verarbeitung auf der Rechtsgrundlage der berechtigten Interessen</h4>
        <p style="padding-left: 20px">
          Der Kunde kann gegen die Verwendung seiner personenbezogenen Daten zu Zwecken der Direktwerbung
          jederzeit und ohne Angabe von Gründen Widerspruch einlegen. Der Widerspruch bewirkt, dass SFA die
          personenbezogenen Daten des Kunden zukünftig nicht mehr zu diesen Zwecken verarbeitet.
        </p>
      </div>
      <div class="data-policy__item">
        <h4>7. Rechtsgrundlage der Datenverarbeitung</h4>
        <ul>
          <li>
            <h5>Online-Nutzung: Vertragserfüllung oder -vorbereitung</h5>
            <p>Die Inanspruchnahme der SFA-Online-Services basiert auf einem Vertrag iSd Art 6 Abs 1 lit b DS-GVO.</p>
          </li>
          <li>
            <h5>Einwilligung</h5>
            <p>
              Für die Übermittlung der Verbindungsdaten an Werbepartner und Drittanbieter holt die SFA
              eine Einwilligung des Kunden ein.<strong>Diese Einwilligung kann jederzeit mit Wirkung für
              die Zukunft widerrufen werden.</strong>
            </p>
          </li>
          <li>
            <h5>Direktwerbung</h5>
            <p>überwiegende berechtigte Interessen von SFA (siehe Punkt 8.)</p>
          </li>
        </ul>
      </div>
      <div class="data-policy__item">
        <h4>8. Beschreibung der (überwiegenden) berechtigten Interessen zu Zwecken</h4>
        <ul>
          <li>
            <h5>der Direktwerbung</h5>
            <p>
              SFA verarbeitet die Kundendaten (nicht jedoch solche von Kindern oder besondere Kategorien
              von personenbezogenen Daten im Sinne des Art 9 DSGVO[4] („sensible Daten“)) auch, um diese zu
              Zwecken der Direktwerbung für (weitere) Produkte von SFA und ihrer Werbekunden zu nutzen
              (siehe dazu auch Punkt 5.). SFA hat an der Verarbeitung personenbezogener Daten zum Zwecke
              der Direktwerbung ein berechtigtes Interesse (Erwägungsgrund 47, letzter Satz der DSGVO).
              Verarbeitet werden dabei ausschließlich jene Kundendaten, über die SFA aus dem Vertragsverhältnis
              verfügt und für die die Speicherfrist läuft. Eine Verlängerung der Speicherfrist erfolgt
              dadurch nicht. Vorrangiges Ziel der Datenverarbeitung ist die Kundengewinnung mit dem Ziel,
              die Reichweite zu erhöhen und dem Kunden Medien- und Werbeinhalte auszuspielen. Dabei stützt
              sich SFA auf ihre auf ihre konventions- und verfassungsrechtlich geschützte Erwerbsfreiheit
              (Art. 6 StGG) und Kommunikationsfreiheit (ins. Art 10 EMRK, der auch Werbemaßnahmen schützt)
              und auf die Rechte
            </p>
            <ul>
              <li>
                <p> zur Übermittlung von postalischer Werbung;</p>
              </li>
              <li>
                <p>zur Vornahme von Werbeanrufen nach Einwilligung;</p>
              </li>
              <li>
                <p>zur Übermittlung von elektronischer Post nach Einwilligung;</p>
              </li>
              <li>
                <p>zur Übermittlung von elektronischer Post gemäß § 107 Abs 3 TKG.</p>
              </li>
            </ul>
            <p><b>Bei der Nutzung dieser Daten hält SFA die kommunikationsrechtlichen Vorgaben,
              insbesondere § 107 TKG, ein. </b></p>
          </li>
          <li>
            <h5>der IT-Sicherheit</h5>
            <p>
              SFA Sport GmbH speichert die IP-Adressen ihrer Kunden für die Dauer von 7 Tagen, um auf
              gezielte Angriffe in Form der Überlastung von Servern („Denial of service“-Angriffe)
              reagieren und andere Schädigungen der Systeme abwehren zu können. An dieser Datenverarbeitung
              zum Zwecke der Aufrechterhaltung der Funktionsfähigkeit ihrer online bereitgestellten Dienste
              hat die SFA Sport GmbH ein überwiegendes berechtigtes Interesse (Erwägungsgrund 49 der DSGVO).
            </p>
          </li>
        </ul>
      </div>
      <div class="data-policy__item">
        <h4>9. Pflicht zur Bereitstellung von Daten</h4>
        <p style="padding-left: 20px">Den Kunden trifft keine Pflicht zur Bereitstellung von Daten.</p>
      </div>
      <div class="data-policy__item">
        <h4>10. Automatisierte Entscheidungsfindung</h4>
        <p style="padding-left: 20px">
          Der Kunde unterliegt <u>keiner</u> automatisierten Entscheidung, die ihm gegenüber
          rechtliche Wirkung entfaltet.
        </p>
      </div>
      <div class="data-policy__item">
        <h4>11. Verarbeitete Datenarten</h4>
        <ul>
          <li>
            <h5>Von Kunden bekannt gegeben</h5>
            <ul>
              <li>Name</li>
              <li>Anschrift(en)</li>
              <li>Telefon- und Telefaxnummer(n)</li>
              <li>E-Mail-Adresse(n)</li>
              <li>Geburtsdatum</li>
              <li>Geschlecht</li>
              <li>Inhalte von Nachrichten des Nutzers</li>
              <li>Nutzername</li>
              <li>Kennwort</li>
              <li>Veröffentlichungen (Artikel-Kommentare, Forenbeiträge,</li>
              <li>Bildeinsendungen (Gewinnspiele, Stadionbesuche)</li>
              <li>Gewinnspielteilnahmen/-Einsendungen</li>
              <li>E-Mail Inhalte bei Kontaktanfragen</li>
              <li>Datenschutzeinwilligung</li>
            </ul>
          </li>
          <li>
            <h5>von SFA zusätzlich erhoben</h5>
            <ul>
              <li>IP-Adressen (Logfiles)</li>
              <li>Daten zum Endgerät</li>
              <li>verwendeter Browser</li><li>User Identity (ID)</li>
              <li>Account Aktivierungsstatus</li>
              <li>Account Erstellungszeitpunkt</li>
              <li>Account Modifikationszeitpunkt</li>
              <li>letzter Loginzeitpunkt</li>
              <li>betrachtete Webseite zum Zeitpunkt der Registrierung</li>
              <li>Anzahl verschickter E-Mail Verifikationsmails</li>
              <li>Zeit bis Login-Erinnerung</li>
              <li>Facebook UID</li>
              <li>Facebook Email</li>
              <li>Facebook Profil Link</li>
              <li>Facebook Update Time</li>
              <li>Interessen</li>
              <li>Session ID</li>
              <li>Webanalyse Identifier</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="data-policy__item">
        <h4>12. Datenquellen (soweit nicht vom Kunden erhoben)</h4>
        <div class="table__container">
          <div class="table__row">
            <div class="table__col"><strong>Quelle</strong></div>
            <div class="table__col flex-col"><strong>Datenarten</strong></div>
          </div>
          <div class="table__row">
            <div class="table__col">Facebook-Login (Facebook Ireland Limited):</div>
            <div class="table__col flex-col">
              E-Mail-Adresse, Geburtsdatum, Name, Geschlecht, Facebook UserName, Facebook-ID,
              Link zur Facebook Seite
            </div>
          </div>
        </div>
      </div>
      <div class="data-policy__item">
        <h4>13. Interne Empfänger von Daten</h4>
        <p style="padding-left: 20px">Geschäftsführung<br/>IT-Servicebetreuer<br/>Marketingabteilung</p>
      </div>
      <div class="data-policy__item">
        <h4>14. Externe Empfänger von Daten</h4>
        <ol class="list-alpha__upper">
          <li>
            <h5>Übermittlung von elektronischen Identifikationsdaten und anderer Datenarten an Verantwortliche</h5>
            <ol style="padding-left: 10px">
              <li>
                <h5>Werbepartner</h5>
                <div class="table__container">
                  <div class="table__row">
                    <div class="table__col flex-col">
                      Krone Multimedia GmbH & Co KG<br>
                      Muthgasse 2, 1190 Wien<br>
                      <a target="_blank" href="https://www.krone.at/1704878">
                        DSGVO - Datenschutzinformation | krone.at
                      </a>
                    </div>
                    <div class="table__col">
                      Elektronische Identifikationsdaten (insb. IP-Adresse, Daten zu den Browsereinstellungen, Cookies)
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <h5>Reichweitenmessung</h5>
                <div class="table__container">
                  <div class="table__row">
                    <div class="table__col flex-col">
                      Reichweitenmessung (Pixel):<br>
                      Österreichische Webanalyse, ZVR 935018357,<br>
                      Köllnerhofgasse 2/8, 1010 Wien,
                      <a target="_blank" href="http://www.oewa.at/impressum">
                        http://www.oewa.at/impressum
                      </a>
                    </div>
                    <div class="table__col">Elektronische Identifikationsdaten</div>
                  </div>
                </div>
              </li>
              <li>
                <h5>Einbindung von Content von Drittanbietern nach ausdrücklicher Einwilligung</h5>
                <div class="table__container">
                  <div class="table__row">
                    <div class="table__col flex-col">
                      Instagram LLC, 1601 Willow Rd, Menlo Park<br>
                      CA 94025, USA,<br>
                      <a target="_blank" href="https://help.instagram.com/">
                        https://help.instagram.com/
                      </a>
                    </div>
                    <div class="table__col">Elektronische Identifikationsdaten</div>
                  </div>
                  <div class="table__row">
                    <div class="table__col flex-col">
                      Twitter Inc., 795 Folsom Street, Suite 600, San Francisco,<br>
                      CA 94107, USA,<br>
                      <a target="_blank" href="https://twitter.com/de/privacy">
                        https://twitter.com/de/privacy
                      </a>
                    </div>
                    <div class="table__col">Elektronische Identifikationsdaten</div>
                  </div>
                  <div class="table__row">
                    <div class="table__col flex-col">
                      Facebook Inc., 1601 S. California Ave, Palo Alto,<br>
                      CA 94304, USA,<br>
                      <a target="_blank" href="https://de-de.facebook.com/about/basics">
                        https://de-de.facebook.com/about/basics
                      </a>
                    </div>
                    <div class="table__col">Elektronische Identifikationsdaten</div>
                  </div>
                  <div class="table__row">
                    <div class="table__col flex-col">
                      YouTube LLC, 901 Cherry Avenue, San Bruno,<br>
                      CA 94066, USA<br>
                      <a target="_blank" href="https://support.google.com/youtube/answer/7671399?hl=de">
                        https://support.google.com/youtube/answer/7671399?hl=de
                      </a>
                    </div>
                    <div class="table__col">Elektronische Identifikationsdaten</div>
                  </div>
                  <div class="table__row">
                    <div class="table__col flex-col">
                      Google LLC, 1600 Amphitheatre Parkway Mountain View,<br>
                      CA 94043, USA<br>
                      <a target="_blank" href="https://policies.google.com/privacy?hl=de">
                        https://policies.google.com/privacy?hl=de
                      </a>
                    </div>
                    <div class="table__col">Elektronische Identifikationsdaten</div>
                  </div>
                </div>
              </li>
            </ol>
          </li>
          <li>
            <h5>Auftragsverarbeiter</h5>
            <ol>
              <li>
                <h5>sonstige Auftragsverarbeiter</h5>
                <p>
                  E-Mail-Kampagnenversand „Mailchimp“: The Rocket Science Group, LLC, 675 Ponce de
                  Leon Ave NE, Suite 5000, Atlanta, GA 30308 USA
                </p>
                <p>
                  Google Analytics: Google LLC, 1600 Amphitheatre Parkway Mountain View, CA 94043, USA
                  Datenschutz:
                  <a target="_blank" href="https://policies.google.com/privacy?hl=de">
                    https://policies.google.com/privacy?hl=de
                  </a>
                </p>
              </li>
              <li>
                <h5> Cloud- und technische Services</h5>
                <p>
                  Amazon WEB Services Emea Sarl, 38 John F. Kennedy L-1855 Luxembourg;
                  Datenschutz:
                  <a target="_blank" href="https://aws.amazon.com/de/privacy/">
                    https://aws.amazon.com/de/privacy/
                  </a>
                </p>
                <p>
                  <strong>
                    SFA behält sich den Einsatz weiterer Auftragsdatenverarbeiter ausdrücklich vor.
                    Diese werden sodann in der auf den Einsatzbeginn folgenden Aktualisierung der
                    Datenschutzinformation ausgewiesen. Alle Auftragsverarbeiter können in Bezug auf
                    datenschutzrechtliche Fragestellungen einheitlich über SFA angeschrieben und erreicht werden.
                  </strong>
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </div>
      <div class="data-policy__item">
        <h4>15. Drittstaatstransfer</h4>
        <p>Folgende Daten werden im Zuge der Datenverarbeitung an Staaten außerhalb der EU übermittelt:</p>
        <div class="table__container">
          <div class="table__row">
            <div class="table__col"><strong>Land/Garantien gemäß Art 46 DSGVO</strong></div>
            <div class="table__col small-col"><strong>Anwendung</strong></div>
            <div class="table__col flex-col"><strong>Datenarten</strong></div>
          </div>
          <div class="table__row">
            <div class="table__col">
              USA<br><br>
              EU-Standardvertragsklauseln<br><br>
              nach ausdrücklicher Einwilligung
            </div>
            <div class="table__col small-col">Google</div>
            <div class="table__col flex-col">
              <strong><u>Google Analytics:</u> anonymisierte</strong> IP-Adresse, Websitetitel,
              browserspezifische Informationen, Informationen über die Websitenutzung;
              <strong><u>Cookie-Setzung nur nach Einwilligung</u></strong><br>
              <strong><u>Einbindung von Content von Drittanbietern nach
                Einwilligung:</u></strong> Elektronische Identifikationsdaten
            </div>
          </div>
          <div class="table__row">
            <div class="table__col">
              USA<br>
              nach ausdrücklicher Einwilligung
            </div>
            <div class="table__col small-col">Youtube</div>
            <div class="table__col flex-col">
              <strong><u>Einbindung von Content von Drittanbietern nach:</u></strong>
              Elektronische Identifikationsdaten
            </div>
          </div>
          <div class="table__row">
            <div class="table__col">
              USA<br>
              nach ausdrücklicher Einwilligung
            </div>
            <div class="table__col small-col">Facebook</div>
            <div class="table__col flex-col">
              <strong><u>Social Plugins:</u></strong> Elektronische Identifikationsdaten<br>
              <strong><u>Facebook Login:</u></strong> Elektronische Identifikationsdaten<br>
            </div>
          </div>
          <div class="table__row">
            <div class="table__col">
              USA<br>
              nach ausdrücklicher Einwilligung
            </div>
            <div class="table__col small-col">Mailchimp</div>
            <div class="table__col flex-col">
              <strong><u>E-Mail-Massenversand:</u></strong> E-Mail-Adresse, Name, Anrede, Geburtsdatum, Region
            </div>
          </div>
          <div class="table__row">
            <div class="table__col">
              USA<br>
              nach ausdrücklicher Einwilligung
            </div>
            <div class="table__col small-col">Twitter</div>
            <div class="table__col flex-col">
              <strong><u>Social Plugins:</u></strong> Elektronische Identifikationsdaten<br>
            </div>
          </div>
        </div>
      </div>
      <div class="data-policy__item">
        <h4>16. Social-Media-Onlineauftritte</h4>
        <p style="padding-left: 20px">
          Der Verantwortliche informiert, dass er zu Zwecken der Werbung und der Kommunikation mit den Kunden
          in Social-Media-Kanälen eigenständige Onlineauftritte abrufbar hält. Bei diesen Onlineauftritten können
          die Daten des Kunden außerhalb der Europäischen Union verarbeitet werden, wodurch ein erhöhtes Risiko
          auf Verletzung des Datenschutzes besteht. Die Betreiber der Social-Media-Kanäle haben sich, soweit
          sie in den USA ansässig sind, größtenteils dem EU-US-Privacy-Shield unterstellt.
        </p>
        <p style="padding-left: 20px">
          Diese Onlineauftritte werden in der technischen Umgebung des jeweiligen Social-Media-Betreibers
          abrufbar gehalten. Die Social-Media-Betreiber nutzen den Besuch des Onlineauftritts durch den Kunden
          sodann für eigene Zwecke, insbesondere um (interessensbasierte) Werbung auszuspielen.
          Die Social-Media-Betreiber nutzen den Besuch, um „Cookies“ am Endgerät des Kunden abzulegen,
          bereits vorhandene Cookies/Identifier auszulesen, aus dem Nutzungsverhalten auf Interessen des
          Kunden zu schließen und damit das zum Kunden oder Identifier angelegte Nutzungsprofil anzureichern.
          Ziel ist dabei die Ausspielung von interessensbasierter Werbung an den Kunden, die auch auf
          später besuchten Websites dritter Anbieter erfolgen kann.
        </p>
        <p style="padding-left: 20px">
          Die Verarbeitung der personenbezogenen Daten des Kunden erfolgt aufgrund der überwiegenden
          berechtigten Interessen des Verantwortlichen an den Werbemaßnahmen und der Kundenkommunikation,
          die durch die Erwerbsfreiheit (Art 6 StGG) und Kommunikationsfreiheit
          (ins. Art 10 EMRK, der auch Werbemaßnahmen schützt) konventions- und verfassungsrechtlich
          geschützt ist. Sind die Kunden Nutzer der Social-Media-Kanäle, so kann die Datenverarbeitung
          auch durch die Einwilligung des Kunden abgedeckt sein.
        </p>
        <p style="padding-left: 20px">
          Der Verantwortliche informiert, dass er auf die Daten des Kunden keinerlei Zugriff hat.
          Der Verantwortliche empfiehlt daher dem Kunden, sich im Falle der Geltendmachung seiner Rechte
          auf Auskunft, Berichtigung, Löschung, Einschränkung, Widerspruch und Datenübertragbarkeit direkt
          an den jeweiligen Social-Media-Kanal zu wenden. Die Nutzer von Social-Media-Kanälen können auch
          selbst im Bereich ihrer Privacy-Einstellungen Änderungen vornehmen. Der Verantwortliche unterstützt
          den Kunden dabei, sollte das erforderlich sein.
        </p>
        <p style="padding-left: 20px">Weitergehende Informationen findet der Kunde unter:</p>
        <p style="padding-left: 20px">
          <u>Facebook (Facebook Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland):</u><br>
          Datenschutzerklärung:
          <a href="https://www.facebook.com/about/privacy/">https://www.facebook.com/about/privacy/</a><br>
          Opt-Out:
          <a href="https://www.facebook.com/settings?tab=ads">https://www.facebook.com/settings?tab=ads</a>
          und
          <a href="http://www.youronlinechoices.com">http://www.youronlinechoices.com</a>
        </p>
        <p style="padding-left: 20px">
          <u>Google/YouTube (Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA):</u><br>
          Datenschutzerklärung:
          <a href="https://policies.google.com/privacy">https://policies.google.com/privacy</a><br>
          Opt-Out:
          <a href="https://adssettings.google.com/authenticated">https://adssettings.google.com/authenticated</a>
        </p>
        <p style="padding-left: 20px">
          <u>Instagram (Instagram Inc., 1601 Willow Road, Menlo Park, CA, 94025, USA):</u><br>
          Datenschutzerklärung/Opt-Out:
          <a href="http://instagram.com/about/legal/privacy/">http://instagram.com/about/legal/privacy/</a>
        </p>
        <p style="padding-left: 20px">
          <u>Twitter (Twitter Inc., 1355 Market Street, Suite 900, San Francisco, CA 94103, USA):</u><br>
          Datenschutzerklärung:
          <a href="https://twitter.com/de/privacy">https://twitter.com/de/privacy</a><br>
          Opt-Out:
          <a href="https://twitter.com/personalization">https://twitter.com/personalization</a>
        </p>
      </div>
      <div class="data-policy__item">
        <h4>17. Gemeinsame Verantwortung mit den Sportvereinen</h4>
        <p style="padding-left: 20px">
          Die Datenverarbeitung der Plattform erfolgt in gemeinsamer Verantwortung der Gemeinden auf
          der Grundlage einer Vereinbarung zur gemeinsamen Verarbeitung nach Art 26 DSGVO. SFA ist für
          sämtliche Belange des Datenschutzes Ansprechpartner.
        </p>
      </div>
      <div class="data-policy__item">
        <h4>18. Speicherdauer</h4>
        <ul>
          <li>
            <h5>Nicht registrierte Nutzer</h5>
            <p>
              Die personenbezogenen Daten (insb. IP-Adresse) von (nicht registrierten) Websitebesuchern
              werden zum Zweck der IT-Sicherheit 7 Tage gespeichert.
            </p>
          </li>
          <li>
            <h5>Registrierte Nutzer</h5>
            <p>
              Die Daten von registrierten Kunden werden von SFA auf Grund der oben genannten Rechtsgrundlage
              grundsätzlich noch 40 Monate nach Vertragsbeendigung
              (= 36 Monate mögliche vertragliche Schadenersatzansprüche + max. 4 Monate Zustelldauer einer Klage)
              personenbezogen verarbeitet und danach (jedenfalls der Personenbezug) gelöscht.
            </p>
          </li>
        </ul>
      </div>
      <div class="data-policy__item">
        <h4>19. Rechte des Betroffenen</h4>
        <div class="table__container">
          <div class="table__row">
            <div class="table__col"><strong>Grundlage</strong></div>
            <div class="table__col flex-col"><strong>Inhalt</strong></div>
          </div>
          <div class="table__row">
            <div class="table__col">Art 15 DSGVO „Auskunft“</div>
            <div class="table__col flex-col">
              Der Kunde hat das Recht, Auskunft darüber zu verlangen, ob personenbezogene
              Daten von ihm verarbeitet werden.
            </div>
          </div>
          <div class="table__row">
            <div class="table__col">Art 16 DSGVO „Berichtigung“</div>
            <div class="table__col flex-col">
              Der Kunde hat das Recht, unverzüglich die Berichtigung unrichtiger personenbezogener Daten
              oder deren Vervollständigung zu verlangen.
            </div>
          </div>
          <div class="table__row">
            <div class="table__col">Art 17 DSGVO „Löschung“</div>
            <div class="table__col flex-col">
              Der Kunde hat das Recht, zu verlangen, dass die personenbezogenen Daten unverzüglich
              gelöscht werden, sofern die in Art 17 Abs 1 DSGVO genannten Gründe erfüllt sind.
            </div>
          </div>
          <div class="table__row">
            <div class="table__col">Art 18 DSGVO „Einschränkung“</div>
            <div class="table__col flex-col">
              Der Kunde hat das Recht, zu verlangen, dass die Verarbeitung der personenbezogenen Daten
              eingeschränkt wird, sofern die in Art 18 Abs 1 DSGVO genannten Gründe erfüllt sind.
            </div>
          </div>
          <div class="table__row">
            <div class="table__col">Art 21 DSGVO „Widerspruch“</div>
            <div class="table__col flex-col">
              Der Kunde hat das Recht, jederzeit Widerspruch gegen die Verarbeitung seiner personenbezogenen
              Daten auf der Rechtsgrundlage des berechtigten Interesse von KMM einzulegen.
            </div>
          </div>
          <div class="table__row">
            <div class="table__col">Art 20 DSGVO „Datenübertragbarkeit“</div>
            <div class="table__col flex-col">
              Der Kunde hat das Recht, seine von ihm bereitgestellten personenbezogenen Daten in einem
              strukturierten, gängigen und maschinenlesbaren Format zu erhalten.
            </div>
          </div>
        </div>
      </div>
      <div class="data-policy__item">
        <h4>20. Beschwerderecht</h4>
        <div class="table__container">
          <div class="table__row">
            <div class="table__col"><strong>Grundlage</strong></div>
            <div class="table__col flex-col"><strong>Inhalt</strong></div>
          </div>
          <div class="table__row">
            <div class="table__col">Art 77 DSGVO § 24 DSG</div>
            <div class="table__col flex-col">
              Jeder Kunde hat das Recht auf Beschwerde bei der Aufsichtsbehörde, wenn er der Ansicht ist,
              dass die Verarbeitung der ihn betreffenden personenbezogenen Daten gegen diese Verordnung verstößt.
            </div>
          </div>
        </div>
      </div>
      <div class="data-policy__item">
        <h4>21. Aufsichtsbehörde</h4>
        <p style="padding-left: 20px">
          Österreichische Datenschutzbehörde<br/>
          Barichgasse 40-42 , 1030 Wien<br/>
          <b>Telefon: +43 1 52 152-0<br/>
          E-Mail: dsb@dsb.gv.at</b>
        </p>
      </div>
    </div>
  </div>
</div>
